module.exports = __webpack_public_path__ + "static/img/19.1c1f4cf1.png";